﻿export default function SkeletonSelect() {
    return (
        <div className="skeleton-select w-100">
            <div className="skeleton-select-placeholder" />
        </div>
    )
}